import React from "react";
import styled from "@emotion/styled";
import colors from '../../../sass/brand_palette.scss';
import { CloseButton } from './CloseButton';
import { SearchIcon } from './SearchIcon';
import { SelectClearButton } from "./SelectClearButton";
import { Mask } from "./Mask";
import withTranslator from "../Translator/withTranslation";

let counted = false;

const CounterContainer = styled.div`
    position: relative;
`;

const CounterButtonsButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: row;
`;

const CounterInlineButton = styled.button`
    padding-left:.85em!important;
    padding-right: .85em!important;
    margin-left: 1px;
    margin-right: 0;
    border-top-left-radius: 0!important;
    border-bottom-left-radius: 0!important;
`;

const CounterInputContainer = styled.div`
    position: relative;
    display:flex;
    border-radius: 3px; 
    color: ${({ counted }) => (counted ? colors.blue1 : colors.grey1)};
    position: relative;
    cursor: pointer;
    &:after {
        display: ${({ inlineDisplay }) => (true ? 'none' : 'block')};
        content: "";
        position: absolute;
        margin-top: -3px;
        right: 17px;
        top: 50%;
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: ${({ open }) => (open ? "0" : "5px solid #F0F0F0")};
        border-bottom: ${({ open }) => (open ? "5px solid #F0F0F0" : "0")};
    }
`;

const CounterButtonsContainer = styled.div`
    text-align:center;
    background: white;
    position: absolute;
    top: 42px;
    padding-top: 3px; 
    overflow: auto;
    width: 100%;
    z-index: 10;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
    box-shadow: 0px 10px 10px -10px;
`;

const CounterButtons = styled.button`
    display:inline-block;
    user-select: none;
    cursor: pointer;
    padding: 0;
    border:0;
    background:none;
`;

const InlineGuestContainer = styled.div`
    flex: 1;
    align-self: center;
    border-top-right-radius:0!important;
    border-bottom-right-radius:0!important;
`;

const CounterImg = styled.img`
    width: 40px;
    height: auto;
    background: white;
    vertical-align: middle;
`;

const CloseButtonContainer = styled.div`
    text-align:right;
`;

class CounterComponent extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            open: false,
            count: props.count ? props.count : 0
        };
       
    }
    
    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }
    
    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
        
        this.setState({
            received: this.props.count
        });
    }
    
    componentDidUpdate(prevProps){
        if(prevProps.count !== this.props.count){
            this.setState({
                count: this.props.count
            });
        }
    }
    
    setWrapperRef = node => {
        this.wrapperRef = node;
    };

    handleClickOutside = event => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.setState({ 
                open: false,
                count: parseInt(this.props.count)
            });
        }
    };

    toggle = () => { 
        const open = !this.state.open;
        
        this.setState({ 
            open: open
        });
        
        if(!open){ 
            this.setState({
                count: this.props.count
            });
        }
    };
    
    incrementCount = (params) =>  {
        var count = this.state.count ? parseInt(this.state.count) : 0;
        count++;
        counted = true;
        
        if(this.props.max && count > this.props.max) count = this.props.max;
        
        this.setState({
            count: count
        });
        
        if(params && params.triggerChange) this.props.onChange(count);
    };

    decrementCount = (params) =>  {
        var count = parseInt(this.state.count);;
    
        if(count > 0){
            count--;
        }
        
        if(count === 0){
            counted = false;
        }
        
        if(this.props.min && count < this.props.min) count = this.props.min;
        
        this.setState({
            count: count
        });
        
        if(params && params.applyValue) this.props.onChange(count);
    };
    
    applyValue = () => {
        this.props.onChange(this.state.count);
        
        this.toggle();
    }
    
    render() {
        const { open } = this.state;
        const { mobile, inlineDisplay, inputName, inputId, containerClass, t, searchFormVariant} = this.props;
        const count = parseInt(this.state.count);
        
        var singularText = this.props.placeholderSingular,
            pluralText = this.props.placeholder;
                        
        let counterInput; 
        
        const clear = <SelectClearButton 
            onChange={(count) => this.props.onChange(count)}
            clearable={this.props.clearable}
            value={count}
        />;
        
        if(!inlineDisplay){
            counterInput = <CounterContainer ref={this.setWrapperRef} className="dropdownCounter"><CounterInputContainer  
                    open={open}
                    onClick={this.toggle}
                    mobile={mobile}
                    counted={counted}
                    className={"btn bg-white select" + (searchFormVariant == 'white' ? ' bor-blue1 bor-solid bor-thin' : ' bor-no')}
                >
                <div className="flex items-center width-100 relative"><SearchIcon src={this.props.iconSrc} show={this.props.withIcon}/><div>{count > 0 ? count : ''}</div>{count > 0 ? <div>&nbsp;</div> : ''}<div className="ucfirst">{count == 1 ? this.props.placeholderSingular : this.props.placeholder}</div>{clear}</div>
                </CounterInputContainer>
                {open && (
                <CounterButtonsContainer className={searchFormVariant == 'white' ? "bor-l-thin bor-b-thin bor-r-thin bor-solid bor-blue1" : ""}>
                    <CounterButtonsButtonContainer>
                    <CounterButtons onClick={() => this.decrementCount()} alt="increase" className="btn-no m-2">
                        <CounterImg src="/assets/img/front/icons/minus-circle-blue1.svg" alt="-"/>
                    </CounterButtons>
                    <CounterButtons onClick={() => this.incrementCount()} alt="Decrease" className="btn-no m-2">
                        <CounterImg src="/assets/img/front/icons/plus-circle-blue1.svg" alt="+"/>
                    </CounterButtons>
                    </CounterButtonsButtonContainer>
                    <CloseButtonContainer className="p-3 flex justify-center">
                        <button 
                            type="button" 
                            className="btn btn-primary btn-sm capitalize"
                            onClick={() => this.applyValue()}
                        >{t('save')}</button>
                    </CloseButtonContainer>
                    <CloseButtonContainer>
                        <CloseButton onClick={this.toggle} />
                    </CloseButtonContainer>
                    {this.props.disabled ?
                    <Mask />
                    :''}            
                </CounterButtonsContainer>
                )}
                {this.props.disabled ?
                <Mask />
                :''}
                </CounterContainer>
        } else {
            counterInput = <CounterInputContainer  
                    mobile={mobile}
                    counted={counted}
                    className="inlineCounter"
                    inlineDisplay={inlineDisplay}
                >
                    <InlineGuestContainer className={"ucfirst btn bor-white bg-white " + containerClass}>{count > 0 ? count + ' ' : ''}{count == 1 ? singularText : pluralText}</InlineGuestContainer>
                    <input type="hidden" id={inputId} name={inputName} value={count} data-counter="true"/>
                    <CounterInlineButton type="button" onClick={this.decrementCount} alt="-" className={"bor-rad-no bg-white bor-white " + containerClass}>&#8722;</CounterInlineButton>
                    <CounterInlineButton type="button" onClick={this.incrementCount} alt="+" className={"bg-white bor-white " + containerClass}>&#43;</CounterInlineButton>
                </CounterInputContainer>
        }
        
        return counterInput;
    }
}

export const Counter = withTranslator(CounterComponent);